module.exports = __webpack_public_path__ + "img/braintree.0cbd79ab.svg";